import React, { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { Controller, useForm, useWatch } from "react-hook-form";
import { DatePicker } from "rsuite";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { printData } from "../../../utility/CommonFunctions";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import SearchSelectBox from "../../../components/comman/SearchSelectBox";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function CreateGRN() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [errorState, setErrorState] = useState("");
  const [files, setFiles] = useState([]);

  // Sub-item substitution state
  const [subItemModal, setSubItemModal] = useState(false);
  const [subItemTarget, setSubItemTarget] = useState({
    expenseIndex: null,
    itemIndex: null,
    expenseHeadId: "",
    poItemName: "",
  });
  const [availableItems, setAvailableItems] = useState([]);
  const [loadingAvailableItems, setLoadingAvailableItems] = useState(false);
  const [selectedSubItemId, setSelectedSubItemId] = useState("");
  const [selectedSubItemQty, setSelectedSubItemQty] = useState("");

  const toggleSubItemModal = () => {
    setSubItemModal(!subItemModal);
  };

  const [state, setState] = useState({
    purchaseList: [],
    siteId: "",
    siteName: "",
    purchaseId: "",
    purchaseLoading: false,
    isLoadingSite: false,
    supplyItems: [],
    EditData: null,
    grnDetails: {},
    loadingItems: false,
    purchaseDetail: [],
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
    financialYear: "--",
  });

  const {
    register,
    setValue,
    getValues,
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", defaultValues: { grnHead: [] } });

  const grnHead = useWatch({ control, name: "grnHead" });

  const GetAllSitesList = (inputValue = null) => {
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_site +
      `?type=site${inputValue ? `&search=${inputValue}` : ""}`;
    callApi(API, options).then((response) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (response?.status === true) {
        setState((prev) => ({
          ...prev,
          OandMSites: response?.data?.site
            ?.filter((item) => item?.type === "O&M")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
          projectSites: response?.data?.site
            ?.filter((item) => item?.type === "project")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
        }));
      }
    });
  };

  const getAssignedSites = (inputValue = null) => {
    const option = {
      method: "GET",
    };
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    const url = `${apiUrl?.get_user_site}${inputValue ? `?search=${inputValue}` : ""
      }`;
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            label: item?.site?.name,
            value: item?.site?.id,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetGrnDetail = (id) => {
    const API = apiUrl?.get_GRN_detail + `grnId=${id}`;
    callApi(API, { method: "GET" }).then((res) => {
      if (res?.status === true) {
        setState((prev) => ({ ...prev, grnDetails: res?.data }));
      }
    });
  };

  const openSubItemModal = (expenseIndex, itemIndex, expenseHeadId, poItemName) => {
    setSubItemTarget({
      expenseIndex,
      itemIndex,
      expenseHeadId,
      poItemName,
    });
    setSelectedSubItemId("");
    setSelectedSubItemQty("");
    setSubItemModal(true);

    setLoadingAvailableItems(true);
    callApi(`${apiUrl.get_items}all=true`, { method: "GET" })
      .then((res) => {
        setLoadingAvailableItems(false);
        if (res?.status === true) {
          const rawItems = res?.data?.items || res?.data?.item || res?.data || [];
          const formatted = (Array.isArray(rawItems) ? rawItems : []).map((i) => ({
            label: `${i.name}${i.itemCode ? ` (${i.itemCode})` : ""}`,
            value: i.id,
            name: i.name,
            unit: i.unit,
          }));
          setAvailableItems(formatted);
        }
      })
      .catch(() => setLoadingAvailableItems(false));
  };

  const handleAddSubItem = () => {
    if (!selectedSubItemId) {
      toast.error("Please select a sub-item.");
      return;
    }
    if (!selectedSubItemQty || parseFloat(selectedSubItemQty) <= 0) {
      toast.error("Please enter a valid quantity.");
      return;
    }

    const foundItem = availableItems.find((i) => i.value === selectedSubItemId);
    const currentGrnHead = getValues("grnHead") || [];
    const { expenseIndex, itemIndex } = subItemTarget;

    if (expenseIndex === null || itemIndex === null) return;

    const targetItem = currentGrnHead[expenseIndex]?.items[itemIndex];
    const existingSubItems = targetItem?.subItems || [];

    if (existingSubItems.some((s) => s.itemId === selectedSubItemId)) {
      toast.error("This sub-item is already added.");
      return;
    }

    const newSubItem = {
      itemId: selectedSubItemId,
      name: foundItem?.name || "Sub-Item",
      quantity: parseFloat(selectedSubItemQty),
      isSubItem: true,
    };

    const updatedSubItems = [...existingSubItems, newSubItem];
    setValue(`grnHead.${expenseIndex}.items.${itemIndex}.subItems`, updatedSubItems);
    setValue(`grnHead.${expenseIndex}.items.${itemIndex}.quantity`, "");

    setSelectedSubItemId("");
    setSelectedSubItemQty("");
    toast.success("Sub-item added.");
  };

  const handleRemoveSubItem = (expenseIndex, itemIndex, subIndex) => {
    const currentGrnHead = getValues("grnHead") || [];
    const targetItem = currentGrnHead[expenseIndex]?.items[itemIndex];
    const existingSubItems = targetItem?.subItems || [];
    const updatedSubItems = existingSubItems.filter((_, idx) => idx !== subIndex);
    setValue(`grnHead.${expenseIndex}.items.${itemIndex}.subItems`, updatedSubItems);
  };

  useEffect(() => {
    if (userDetails?.type === 2) {
      GetAllSitesList();
    } else {
      getAssignedSites();
    }
    if (location?.state?.type === "Create") {
      const API =
        apiUrl?.get_purchase_detail + `purchaseId=${location?.state?.data?.id}`;
      callApi(API, { method: "GET" }).then((res) => {
        if (res?.status === true) {
          setState((prev) => ({ ...prev, purchaseDetail: res?.data }));
        }
      });
    } else if (location?.state?.type === "Update") {
      GetGrnDetail(location?.state?.data?.id);
    }
  }, []);

  useEffect(() => {
    if (location?.state?.type === "Create" && state?.purchaseDetail) {
      setState((prev) => ({
        ...prev,
        purchaseId: state?.purchaseDetail.id,
        siteId: state?.purchaseDetail?.purchaserequest?.site?.id,
        siteName: state?.purchaseDetail?.purchaserequest?.site?.name,
        financialYear: state?.purchaseDetail?.financialYear || "--",
      }));
      const grnHead =
        state?.purchaseDetail?.purchaserequest?.purchaserequestexpenseheads?.map(
          (expense) => ({
            expenseHeadId: expense?.expenseHeadId,
            name: expense?.expensehead?.name,
            items: expense?.supplyrequestitems?.map((item) => ({
              poItemId: item?.id,
              itemId: item?.itemId,
              name: item?.item?.name,
              updatedQuantity: item?.updatedQuantity,
              receivedQuantity: item?.receivedQuantity || 0,
              remainingQuantity:
                parseFloat(item?.updatedQuantity) -
                parseFloat(item?.receivedQuantity || 0),
              quantity: "",
              subItems: [],
            })),
          })
        );

      reset({
        grnHead,
        siteId: state?.purchaseDetail?.purchaserequest?.site?.id,
      });
    }

    if (location?.state?.type === "Update" && state?.grnDetails) {
      setState((prev) => ({
        ...prev,
        purchaseId: state?.grnDetails?.purchase?.id,
        siteId: state?.grnDetails?.site?.id,
        siteName: state?.grnDetails?.site?.name,
        financialYear: state?.grnDetails?.purchase?.financialYear || "--",
      }));
      const grnHead =
        state?.grnDetails?.purchase?.purchaserequest?.purchaserequestexpenseheads?.map(
          (expense) => {
            const expenseHead = state?.grnDetails?.grnheads?.find(
              (exp) => exp?.expensehead?.id === expense?.expensehead?.id
            );
            return {
              expenseHeadId: expense?.expenseHeadId,
              name: expense?.expensehead?.name,
              items: expense?.supplyrequestitems?.map((item) => {
                const foundItemsQuantity = expenseHead?.grnitems?.find(
                  (qty) => qty?.item?.id === item?.item?.id
                );
                printData(expenseHead, foundItemsQuantity);
                return {
                  poItemId: item?.id,
                  itemId: item?.itemId,
                  name: item?.item?.name,
                  updatedQuantity: item?.updatedQuantity,
                  receivedQuantity: item?.receivedQuantity || 0,
                  remainingQuantity:
                    parseFloat(item?.updatedQuantity) -
                    parseFloat(item?.receivedQuantity || 0),
                  quantity: foundItemsQuantity?.quantity || "",
                  subItems: [],
                };
              }),
            };
          }
        );

      reset({
        content: state?.grnDetails?.description || "",
        siteId: state?.grnDetails?.site?.id,
        grnHead,
      });

      if (state?.grnDetails?.documents?.length > 0) {
        setExistingDocuments(state?.grnDetails?.documents);
      }
    }
  }, [state?.grnDetails, state?.purchaseDetail]);

  const fetchPurchaseOrderList = (inputValue) => {
    return new Promise((resolve) => {
      const site = state?.siteId || "";
      const API = `${apiUrl.get_purchase
        }from=grn&type=supplyRequest&siteId=${site}${inputValue ? `&search=${inputValue}` : ""
        }`;

      setState((prev) => ({ ...prev, purchaseLoading: true }));

      callApi(API, { method: "GET" }).then((res) => {
        setState((prev) => ({ ...prev, purchaseLoading: false }));
        if (res?.status) {
          const formatted = res?.data?.purchase?.map((p) => ({
            value: p.id,
            label: p.purchaseNumber,
          }));

          const selectedPurchase = res?.data?.purchase?.find(
            (p) => p?.id === location?.state?.data?.purchaseId
          );

          setState((prev) => ({
            ...prev,
            purchaseList: res?.data?.purchase,
          }));

          resolve(formatted);
        } else resolve([]);
      });
    });
  };

  const onSubmit = (data) => {
    const { grnHead, content } = data;

    if (!state?.siteId) {
      toast.error("Please select site.");
      return;
    }

    const grnhead = grnHead
      ?.map((head) => {
        const grnItem = [];
        (head.items || []).forEach((item) => {
          if (item.subItems && item.subItems.length > 0) {
            item.subItems.forEach((sub) => {
              if (sub.itemId && sub.quantity && parseFloat(sub.quantity) > 0) {
                grnItem.push({
                  itemId: sub.itemId,
                  quantity: parseFloat(sub.quantity),
                  poItemId: item.poItemId || item.itemId,
                  isSubItem: true,
                });
              }
            });
          } else if (item.quantity && parseFloat(item.quantity) > 0) {
            grnItem.push({
              itemId: item.itemId,
              quantity: parseFloat(item.quantity),
              poItemId: item.poItemId || item.itemId,
              isSubItem: false,
            });
          }
        });

        return {
          expenseHeadId: head.expenseHeadId,
          grnItem,
        };
      })
      .filter((head) => head.grnItem.length > 0);

    const totalValidItems = grnhead.reduce(
      (acc, head) => acc + head.grnItem.length,
      0
    );
    if (totalValidItems === 0) {
      toast.error("Please enter quantity or add sub-items for at least one item.");
      return;
    }

    const postData = {
      date: data.date,
      description: content,
      grnHead: JSON.stringify(grnhead),
      siteId: state.siteId,
      purchaseId: state.purchaseId,
    };

    // console.log(postData);

    const formData = new FormData();
    for (const key in postData) {
      if (postData[key]) formData.append(key, postData[key]);
    }

    files.forEach((f) => formData.append(f.file.name, f.file));

    const isUpdate = location?.state?.type === "Update";
    const api = isUpdate
      ? `${apiUrl.update_GRN}?grnId=${location?.state?.data?.id}`
      : apiUrl.create_GRN;
    const method = "POST";

    setIsLoading(true);
    callApi(api, { method, form_data: formData })
      .then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(
            response?.message ||
            `${isUpdate ? "Updated" : "Created"} GRN successfully.`
          );
          navigate(RoutesLink.grn);
        } else {
          toast.error(response?.message || "Something went wrong.");
        }
      })
      .catch((error) => {
        toast.error("An unexpected error occurred.");
        console.error(error);
      });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile }, // Use file name as key
      ]);
    }
    event.target.value = ""; // Allow reselecting the same file
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName)
    );
  };

  const handleDeleteDocument = (docId) => {
    const API = `${apiUrl.delete_document}?documentId=${docId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        setExistingDocuments((prev) => prev.filter((doc) => doc.id !== docId));
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const handleSelectPO = (data) => {
    let API = apiUrl?.get_purchase_detail + `purchaseId=${data?.value}`;
    setState((prev) => ({
      ...prev,
      loadingItems: true,
    }));
    callApi(API).then((response) => {
      setState((prev) => ({
        ...prev,
        loadingItems: false,
      }));
      if (response?.status) {
        setState((prev) => ({
          ...prev,
          purchaseId: data?.value,
          financialYear: response?.data?.financialYear || "--",
        }));
        const grnHead =
          response?.data?.purchaserequest?.purchaserequestexpenseheads?.map(
            (expense) => ({
              expenseHeadId: expense?.expenseHeadId,
              name: expense?.expensehead?.name,
              items: expense?.supplyrequestitems?.map((item) => ({
                itemId: item?.itemId,
                name: item?.item?.name,
                updatedQuantity: item?.updatedQuantity,
                receivedQuantity: item?.receivedQuantity || 0,
                remainingQuantity:
                  parseFloat(item?.updatedQuantity) -
                  parseFloat(item?.receivedQuantity || 0),
                quantity: "",
              })),
            })
          ) || [];

        reset({
          grnHead,
          // siteId: state?.purchaseDetail?.purchaserequest?.siteId,
        });
      }
    });
  };

  // printData("SupplyItems", state?.supplyItems);

  return (
    <>
      {state.loadingItems && <BgBlurLoader />}
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.type ? location?.state?.type : "Create"} GRN
            </h1>
          </div>
        </div>
        <form id="againstPO" onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteId: option?.value,
                              siteName: option?.label,
                              financialYear: "--",
                            }));
                          }}
                          onBlur={field.onBlur}
                          options={
                            userDetails?.type === 2
                              ? state?.OandMSites
                              : state.assignedSites
                          }
                          onSearch={
                            userDetails?.type === 2
                              ? GetAllSitesList
                              : getAssignedSites
                          }
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={location?.state?.data}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3 position-relative">
                    <label htmlFor="customerSearch" className="form-label">
                      Purchase Order
                    </label>

                    {/* Search Input */}
                    <SearchSelectBox
                      value={state?.purchaseId}
                      fetchOptions={fetchPurchaseOrderList}
                      loading={state.purchaseLoading}
                      isAsync={true}
                      defaultFetch={state.siteId}
                      title={
                        (
                          state?.purchaseList?.length === 0 ||
                            location?.state?.data
                            ? true
                            : false
                        )
                          ? "No record found"
                          : "Search Purchase Order"
                      }
                      error={errorState}
                      disable={location?.state?.data ? true : false}
                      onChange={handleSelectPO}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Financial Year
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={state.financialYear || "--"}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const today = moment().startOf('day');
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          shouldDisableDate={(date) => date > new Date()}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>

                {/* <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={toggleModal}
                    disabled={location?.state?.type === "Create" ? !state?.grnDetails?.purchaserequest
                      ?.purchaserequestexpenseheads : !state?.grnDetails?.grnheads}
                  >
                    Add Material
                  </button>
                </div> */}

                {grnHead?.length > 0 && (
                  <div className="mt-4 w-100">
                    {grnHead.map((expense, index) => (
                      <div key={index} className="card border mb-4">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h3 className="text-primary m-0">{expense.name}</h3>
                          </div>
                          {expense?.items?.length > 0 && (
                            <div className="table-responsive">
                              <table className="table table-bordered table-striped align-middle">
                                <thead className="table-light">
                                  <tr>
                                    <th>Item Name</th>
                                    <th>Approved Quantity</th>
                                    <th>Received Quantity</th>
                                    <th>Remaining Quantity</th>
                                    <th>Quantity</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {expense.items.map((item, i) => {
                                    const currentSubItems = item?.subItems || [];
                                    const hasSubItems = currentSubItems.length > 0;
                                    return (
                                      <React.Fragment key={i}>
                                        <tr>
                                          <td>
                                            <div className="fw-semibold">{item.name}</div>
                                            {hasSubItems && (
                                              <span className="badge bg-warning text-dark mt-1">
                                                Substituted ({currentSubItems.length} sub-items)
                                              </span>
                                            )}
                                          </td>
                                          <td>{item.updatedQuantity}</td>
                                          <td>{item.receivedQuantity}</td>
                                          <td>{item.remainingQuantity}</td>
                                          <td style={{ minWidth: "120px" }}>
                                            <input
                                              type="number"
                                              disabled={hasSubItems}
                                              onWheel={(e) => e.target.blur()}
                                              className={`form-control ${errors?.grnHead?.[index]?.items?.[i]?.quantity ? "is-invalid" : ""}`}
                                              placeholder={hasSubItems ? "Substituted" : "Quantity"}
                                              {...register(
                                                `grnHead.${index}.items.${i}.quantity`,
                                                {
                                                  validate: (value) => {
                                                    if (hasSubItems) return true;
                                                    if (!value) return true;
                                                    let qty = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                                    if (!/^\d*\.?\d*$/.test(value)) value = "";
                                                    setValue(`grnHead.${index}.items.${i}.quantity`, qty);
                                                    const numericValue = Number(qty);
                                                    const remainingQty = item.remainingQuantity;
                                                    if (numericValue > remainingQty) {
                                                      return `Quantity cannot exceed ${remainingQty}`;
                                                    }
                                                    return true;
                                                  },
                                                }
                                              )}
                                            />
                                            {errors?.grnHead?.[index]?.items?.[i]?.quantity && (
                                              <div className="invalid-feedback">
                                                {errors.grnHead[index].items[i].quantity.message}
                                              </div>
                                            )}
                                          </td>
                                          <td>
                                            <button
                                              type="button"
                                              className={`btn btn-sm ${hasSubItems ? "btn-warning" : "btn-outline-primary"} text-nowrap`}
                                              onClick={() => openSubItemModal(index, i, expense.expenseHeadId, item.name)}
                                            >
                                              {hasSubItems ? `Sub-Items (${currentSubItems.length})` : "+ Substitute"}
                                            </button>
                                          </td>
                                        </tr>
                                        {hasSubItems && (
                                          <tr>
                                            <td colSpan="6" className="bg-light p-3">
                                              <div className="fw-bold text-secondary mb-2 small">
                                                DELIVERED SUB-ITEMS FOR "{item.name}":
                                              </div>
                                              <div className="d-flex flex-wrap gap-2">
                                                {currentSubItems.map((sub, sIdx) => (
                                                  <span key={sIdx} className="badge bg-primary fs-6 p-2 d-inline-flex align-items-center gap-2">
                                                    <span>{sub.name} &mdash; <strong>Qty: {sub.quantity}</strong></span>
                                                    <button
                                                      type="button"
                                                      className="btn-close btn-close-white ms-1"
                                                      style={{ fontSize: "0.65rem", cursor: "pointer" }}
                                                      onClick={() => handleRemoveSubItem(index, i, sIdx)}
                                                      title="Remove Sub-Item"
                                                    />
                                                  </span>
                                                ))}
                                              </div>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="row">
                  <div className="col-12  " />
                  <div className="col-12 col-md-6 col-lg-5">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="ref">
                        Uploads
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="documentUpload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="documentUpload"
                        className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                          padding: 5,
                          backgroundColor: "rgb(245, 245, 245)",
                          borderRadius: 8,
                          minWidth: 150,
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="placeholder-img">
                            <UploadPlusIcon />
                          </span>
                          <span className="text-muted">Choose Files </span>
                        </div>
                      </label>
                      <div className="preview-section p-1 mt-3" />
                    </div>
                  </div>
                </div>
                {/* File Preview Section */}
                <div className="preview-section p-1 mt-3 col-lg-5">
                  {files?.length > 0 &&
                    files.map((fileObj) => (
                      <div
                        key={fileObj.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            setSelectedDocument(fileObj?.file);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{fileObj?.file?.name}</span>
                        </div>
                        <button
                          className="text-danger mx-2 bg-light"
                          onClick={() => removeFile(fileObj.key)} // Remove using file name
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}

                  {existingDocuments?.length > 0 &&
                    existingDocuments.map((doc) => (
                      <div
                        key={doc.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            const docUrl = {
                              url: doc?.url,
                            };
                            setSelectedDocument(docUrl);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{doc?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => handleDeleteDocument(doc.id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}
                </div>

                {/* <div className="col-12 col-md-6 col-lg-8 w-100">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control "
                      id="desc"
                      rows="3"
                      {...register("description")}
                    />
                  </div>
                </div> */}
                <div className="col-12 ">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Description
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                      name="content"
                      control={control}
                      rules={
                        {
                          // required: "Description is required",
                        }
                      }
                      render={({ field }) => (
                        <div>
                          <CKEditor
                            {...field}
                            editor={ClassicEditor}
                            data={field.value || ""}
                            onChange={(event, editor) => {
                              field.onChange(editor.getData());
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "|",
                                "fontColor",
                                "fontBackgroundColor",
                                "fontFamily",
                                "fontSize",
                                "alignment",
                                "|",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "undo",
                                "redo",
                              ],
                              image: {
                                toolbar: [
                                  "imageStyle:alignLeft",
                                  "imageStyle:alignCenter",
                                  "imageStyle:alignRight",
                                  "|",
                                  "imageTextAlternative",
                                ],
                              },
                              height: "500px",
                            }}
                          />
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? (
                    <Spinner />
                  ) : location?.state?.type ? (
                    location?.state?.type
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />

      <Modal isOpen={subItemModal} toggle={toggleSubItemModal} size="lg" centered>
        <ModalHeader toggle={toggleSubItemModal}>
          <span>Substitute Item / Add Sub-Items: </span>
          <span className="text-primary fw-bold">{subItemTarget.poItemName}</span>
        </ModalHeader>
        <ModalBody>
          <div className="alert alert-info py-2 mb-3 fs-5">
            Add delivered sub-items/components for <strong>"{subItemTarget.poItemName}"</strong>. Sub-items will be added to site inventory stock, and the main PO item will be marked as received.
          </div>
          {loadingAvailableItems ? (
            <div className="text-center py-4">
              <Spinner color="primary" /> <span className="ms-2">Loading items...</span>
            </div>
          ) : (
            <div className="card border-0 bg-light p-3 rounded-3 mb-3">
              <div className="row g-3 align-items-end">
                <div className="col-12 col-md-6">
                  <label className="form-label fw-bold mb-1">Select Sub-Item</label>
                  <SearchSelectBox
                    options={availableItems}
                    value={selectedSubItemId}
                    onChange={(option) => setSelectedSubItemId(option?.value || "")}
                    placeholder="Select an option"
                    noMargin={true}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label fw-bold mb-1">Quantity</label>
                  <input
                    type="number"
                    min="1"
                    step="any"
                    className="form-control"
                    placeholder="Qty"
                    value={selectedSubItemQty}
                    onChange={(e) => setSelectedSubItemQty(e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <button
                    type="button"
                    className="btn btn-primary w-100 fw-semibold"
                    onClick={handleAddSubItem}
                  >
                    + Add
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Current Sub-Items for target item */}
          {(() => {
            const currentGrnHead = getValues("grnHead") || [];
            const { expenseIndex, itemIndex } = subItemTarget;
            const currentSubItems =
              expenseIndex !== null && itemIndex !== null
                ? currentGrnHead[expenseIndex]?.items[itemIndex]?.subItems || []
                : [];
            if (currentSubItems.length === 0) return null;

            return (
              <div className="mt-3">
                <h6 className="fw-bold text-primary mb-2">
                  Added Sub-Items ({currentSubItems.length}):
                </h6>
                <div className="table-responsive">
                  <table className="table table-bordered table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "50px" }} className="text-center">#</th>
                        <th>Sub-Item Name</th>
                        <th style={{ width: "120px" }} className="text-center">Quantity</th>
                        <th style={{ width: "90px" }} className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentSubItems.map((sub, sIdx) => (
                        <tr key={sIdx}>
                          <td className="text-center">{sIdx + 1}</td>
                          <td className="fw-semibold">{sub.name}</td>
                          <td className="text-center fw-semibold">{sub.quantity}</td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleRemoveSubItem(expenseIndex, itemIndex, sIdx)}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })()}
        </ModalBody>
        <ModalFooter>
          <Button color="success" className="px-4 fw-semibold" onClick={toggleSubItemModal}>
            Done
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

